module.exports = __webpack_public_path__ + "static/img/shyy_img_nqhy.14b3a09.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shyy_img_nqhy.png
// module id = QOCD
// module chunks = 0